import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
 
   connect() {
    const modal = document.getElementById('detailModal');
    if (modal) {
      modal.addEventListener('show.bs.modal', function (event) {
        // 取得點擊按鈕的 data-innerhtml
          const button = event.relatedTarget;
          const innerHtml = button.dataset.innerhtml;

          $('#detailModal .modal-body').html(innerHtml);
      })
    }
  }
 
}
